import { Inject, Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, RouterStateSnapshot } from '@angular/router';
import { OKTA_AUTH } from '@okta/okta-angular';
import OktaAuth from '@okta/okta-auth-js';

@Injectable()
export class LoginRedirectGuard {

    constructor(@Inject(OKTA_AUTH) private oktaAuth: OktaAuth) {
    }

    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): boolean {
        const returnUrl = route.queryParams.returnUrl as string;
        if (returnUrl) {
            this.oktaAuth.setOriginalUri(returnUrl);
        }
        void this.oktaAuth.signInWithRedirect();
        return false;
    }
}
